module.exports = __webpack_public_path__ + "static/media/PlaceholderQR.0c4a3c85.svg";